import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'

Vue.use(Router)

export default new Router({
  base: process.env.VUE_APP_BASE,
  mode: 'history',
  routes: [
    {
      path: '/:tenant',
      name: 'home',
      component: Home
    },
    {
      path: '/:tenant/calendar',
      name: 'calendar',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "calendar" */ '@/views/CalendarView.vue')
    },
    {
      path: '/:tenant/legal',
      name: 'legal',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "calendar" */ '@/views/LegalView.vue')
    },
    {
      path: '/:tenant/gallery/:id',
      name: 'gallery',
      component: () => import(/* webpackChunkName: "gallery" */ '@/views/Gallery.vue')
    },
    {
      path: '/:tenant/sign/:id',
      name: 'sign',
      props: true,
      component: () => import(/* webpackChunkName: "gallery" */ '@/views/Sign.vue')
    }
  ]
})
